import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { LivretEval } from '../types/livret';
import livretKeys from './keys';
import { getNotationsHelperAttributes } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/utils/getNotationsHelperAttributes';
import { deserialize } from '@teetsh/app/src/containers/Livrets/queries/serializer';

interface Props {
  livretEvalId: string;
}

function getLivretEval({
  schoolyearId,
  schoolId,
  livretEvalId,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEvalId: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets/${livretEvalId}`;
  return request(requestURL, {
    method: 'GET',
  }).then<LivretEval>(p => {
    const notSystem = p.notationSystem;
    return {
      ...deserialize(p),
      notationSystem: {
        ...notSystem,
        ...getNotationsHelperAttributes(notSystem),
      },
    };
  });
}

export function useLivretEval(props: Props) {
  const { livretEvalId } = props;
  const { schoolyear, school } = useSchoolSchoolyear();

  return useQuery({
    queryKey: livretKeys.livretDetail(schoolyear.id, school.id, livretEvalId),
    queryFn: () =>
      getLivretEval({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEvalId,
      }),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 4;
    },
  });
}
